import { useState } from "react";
import { AlertCircle, Eye, EyeOff } from "lucide-react";
import { TextInput } from "../crm/leadsKit";

// Design: components/ui.tsx. Only the pieces not already ported elsewhere
// (Field, TextInput, PrefixInput, SelectInput, GhostButton, isEmail live in
// crm/leadsKit; Checkbox in crm/contactsKit; PrimaryButton in ui.js).

export function PasswordInput({ invalid, ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <TextInput {...props} invalid={invalid} type={show ? "text" : "password"} className="pr-12" />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Hide password" : "Show password"}
        className="absolute top-1 right-1 flex h-10 w-10 items-center justify-center rounded-xs text-muted hover:text-ink"
      >
        {show ? <EyeOff size={18} strokeWidth={1.75} /> : <Eye size={18} strokeWidth={1.75} />}
      </button>
    </div>
  );
}

export function FormError({ children }) {
  return (
    <div role="alert" className="flex items-start gap-3 rounded-md bg-danger-soft px-4 py-3 text-small text-danger">
      <AlertCircle size={18} strokeWidth={1.75} className="mt-0.5 shrink-0" />
      <span>{children}</span>
    </div>
  );
}
